module.exports = __webpack_public_path__ + "static/media/worldmap.0c67328f.jpg";